import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./about.css";
import NavbarAll from "../Navbar/NavbarAll";

const About = () => {
  const imagesIntro = [
    "https://kkwt.org/wp-content/uploads/2024/06/New-office-scaled.jpg",
    "https://kkwt.org/wp-content/uploads/2024/06/IMG20210831145831-scaled.jpg",
    "https://kkwt.org/wp-content/uploads/2024/06/IMG20210314141905-scaled.jpg",
    "https://kkwt.org/wp-content/uploads/2024/06/IMG20210314141857-scaled.jpg",
    "https://kkwt.org/wp-content/uploads/2024/06/IMG20210314141853-scaled.jpg",
    "https://kkwt.org/wp-content/uploads/2024/06/6cc05dd2-d15a-46a8-a601-18ab2c5fab2c.jpg",
  ];

  const imagesMission = [
    "https://kkwt.org/wp-content/uploads/2024/06/a6301582-1867-4337-abfd-8d9e79c4b56a.jpg",
    "https://kkwt.org/wp-content/uploads/2024/06/IMG-20210414-WA0244.jpg",
    "https://kkwt.org/wp-content/uploads/2024/06/Untitled-1.jpg",
  ];

  const imagesVision = [
    "https://kkwt.org/wp-content/uploads/2024/06/IMG-20210416-WA0137.jpg",
  ];

  const [activeSection, setActiveSection] = useState("introduction");
  const [preloaderVisible, setPreloaderVisible] = useState(true);

  const sectionItems = [
    { key: "introduction", label: "Introduction" },
    { key: "mission", label: "Mission Story" },
    { key: "vision", label: "Our Vision" },
    { key: "objectives", label: "Our Objectives" },
    { key: "areas", label: "Focus Areas" },
    { key: "corevalues", label: "Core Values" },
    { key: "ceomessage", label: "CEO's Message" },
    { key: "certificateandrewards", label: "Certificate & Rewards" },
  ];

  useEffect(() => {
    try {
      setPreloaderVisible(false);
    } catch (error) {
      setPreloaderVisible(false);
    }
  }, [preloaderVisible]);

  return (
    <>
      <NavbarAll />
      {/* ======= PAGE HEADER ======= */}
      <section>
        <div className="w-100 pt-80 black-layer pb-70 opc65 position-relative">
          <div
            className="fixed-bg"
            style={{
              backgroundImage: `url(https://kkwt.org/wp-content/uploads/2024/06/IMG20200826164220-1-scaled.jpg)`,
            }}
          ></div>
          <div className="container">
            <div className="page-title-wrap text-center w-100">
              <div className="page-title-inner d-inline-block">
                <h1 className="mb-0">About Us</h1>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/" title="Home">
                      Masjid - Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">About</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ======= ABOUT CONTENT ======= */}
      <div className="about-container">
        {/* Desktop: Sidebar Navigation (sticky) */}
        <aside className="about-sidebar">
          <nav className="about-sidebar-nav">
            <span className="about-sidebar-title">Sections</span>
            <ul>
              {sectionItems.map((item) => (
                <li key={item.key}>
                  <button
                    type="button"
                    className={activeSection === item.key ? "active" : ""}
                    onClick={() => setActiveSection(item.key)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        {/* Mobile: Horizontal section pills (sticky at top) */}
        <div className="about-mobile-nav" aria-label="Page sections">
          <div className="about-mobile-nav-scroll">
            {sectionItems.map((item) => (
              <button
                key={item.key}
                type="button"
                className={`about-pill ${activeSection === item.key ? "active" : ""}`}
                onClick={() => setActiveSection(item.key)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        {/* Main Content Section */}
        <div className="about-content">
          {activeSection === "introduction" && (
            <section>
              <h2>INTRODUCTION</h2>
              <p>
                Khadija-tul-Kubra Welfare Trust (KWT) is a reliable and
                trustworthy social welfare organization which works round the
                clock to help the poor, needy and deserving in fulfilling their
                basic human necessities.
              </p>
              <p>
                Khadija Tul Kubra Welfare Trust has been named after Hazrat
                Khadijah رضی اللہ عنہا, the 1st wife of the Holy Prophet صلی
                اللہ علیہ وسلم, urging the Muslims to get inspiration from her
                welfare services. It also reminds us of how she dedicated her
                entire wealth and property to the service of Islam and humanity.
              </p>
              <p>
                The KWT provides services in more than twelve social and
                educational domains and uses the contributions of generous
                donors to educational and social domains with integrity and
                professionalism.
              </p>
              <p>
                KWT is carrying out its activities under the auspices of
                professionals in compliance with Shariah principles along with
                the national and international laws.
              </p>
              <div className="gallery-container">
                <div className="gallery-grid">
                  {imagesIntro.map((image, index) => (
                    <div key={index} className="gallery-item">
                      <img src={image} alt={`Gallery item ${index + 1}`} />
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {activeSection === "mission" && (
            <section>
              <h2>OUR MISSION</h2>
              <p>
                KWT believes that the primary reason behind the increasing
                poverty, challenges, and overall decline of the Muslim Ummah—
                despite being blessed with immense resources—is the neglect of
                the divine way of life prescribed by Allah SWT.
              </p>
              <p>
                KWT’s mission is to inspire and engage Muslim philanthropists in
                transforming lives across the world through education,
                community development, and humanitarian services.
              </p>
              <div className="gallery-container">
                <div className="gallery-grid">
                  {imagesMission.map((image, index) => (
                    <div key={index} className="gallery-item">
                      <img src={image} alt={`Mission ${index + 1}`} />
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {activeSection === "vision" && (
            <section>
              <h2>OUR VISION</h2>
              <p>
                To become a mainstream NGO in poverty mitigation & welfare
                services by making a significant positive impact on disadvantaged
                communities through fundraising and impactful projects.
              </p>
              <div className="gallery-container">
                <div className="gallery-grid">
                  {imagesVision.map((image, index) => (
                    <div key={index} className="gallery-item">
                      <img src={image} alt={`Vision ${index + 1}`} />
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {activeSection === "objectives" && (
            <section className="objectives-section">
              <h2>OUR OBJECTIVES</h2>
              <div className="objectives-container">
                <div className="objective-box">
                  <h3>COMMUNITY EMPOWERMENT</h3>
                  <p>
                    Support deprived communities to become self-reliant through
                    technical and financial assistance.
                  </p>
                </div>

                <div className="objective-box">
                  <h3>EDUCATION RELATED SERVICES</h3>
                  <p>
                    Establish and improve educational institutions using modern
                    methods and technology.
                  </p>
                </div>

                <div className="objective-box">
                  <h3>HEALTHCARE</h3>
                  <p>
                    Provide and strengthen primary-level healthcare services.
                  </p>
                </div>

                <div className="objective-box">
                  <h3>ORPHANS SUPPORT</h3>
                  <p>
                    Build orphanages offering education, healthcare, training,
                    and shelter for orphans.
                  </p>
                </div>

                <div className="objective-box">
                  <h3>SOCIAL AWARENESS</h3>
                  <p>
                    Provide education and training to raise awareness levels in
                    communities.
                  </p>
                </div>

                <div className="objective-box">
                  <h3>DISASTER RELIEF</h3>
                  <p>
                    Deliver relief and rehabilitation services to those affected
                    by calamities.
                  </p>
                </div>
              </div>
            </section>
          )}

          {activeSection === "corevalues" && (
            <section className="objectives-section">
              <h2>OUR CORE VALUES</h2>
              <div className="objectives-container">
                <div className="objective-box">
                  <h3>Shariah Compliance</h3>
                  <p>
                    To seek guidance from Shariah in every aspect of KWT’s
                    operations.
                  </p>
                </div>
                <div className="objective-box">
                  <h3>Transparency</h3>
                  <p>To enforce justice and fairness in all operations.</p>
                </div>
                <div className="objective-box">
                  <h3>Teamwork</h3>
                  <p>To build sincerity, ownership & family spirit in teams.</p>
                </div>
                <div className="objective-box">
                  <h3>Professionalism</h3>
                  <p>
                    To embrace the highest standards of integrity & knowledge.
                  </p>
                </div>
              </div>
            </section>
          )}

          {activeSection === "areas" && (
            <section>
              <h2>THEMATIC AREAS</h2>
              <p>
                Our organization focuses on education, humanitarian aid, and
                social welfare for the betterment of the community.
              </p>
            </section>
          )}

          {activeSection === "ceomessage" && (
            <section className="ceo-message">
              <div className="ceo-content">
                <img
                  src="https://ik.imagekit.io/nfs93gxmp/CEO%20Image.jpg"
                  alt="CEO"
                  className="ceo-image"
                />
                <div className="ceo-text">
                  <p className="greeting">السلام عليكم ورحمة الله وبركاته</p>
                  <blockquote className="quran-verse">
                    Allah SWT says: <br />
                    <strong>وَتَعَاوَنُوا عَلَى الْبِرِّ وَالتَّقْوَىٰ</strong>{" "}
                    <br />
                    <em>
                      “And cooperate with one another in righteousness and
                      piety!”
                    </em>{" "}
                    (Qur'an, Surah Al-Maidah: 2)
                  </blockquote>
                  <p>
                    It is the command of Allah to do good deeds together and to
                    help humanity by helping one another in good deeds.
                  </p>
                  <p>
                    Praise be to Allah, The{" "}
                    <strong>KHADIJA TUL KUBRA WELFARE TRUST</strong> is a
                    trustworthy organization delivering basic human needs to
                    deserving people.
                  </p>
                  <h3 className="ceo-name">Muhammad Fayyaz</h3>
                  <p className="ceo-title">CEO (Chief Executive Officer)</p>
                </div>
              </div>
            </section>
          )}

          {activeSection === "certificateandrewards" && (
            <section>
              <h2>CERTIFICATIONS & AWARDS</h2>
              <ul>
                <li>PCP Certificate</li>
                <li>Sindh Charity Commission Certificate</li>
                <li>Sindh Health-Care Commission Certificate</li>
                <li>FBR Tax Certificates</li>
                <li>Shariah Compliant Certificate</li>
                <li>CSR Award</li>
              </ul>
            </section>
          )}
        </div>
      </div>
    </>
  );
};

export default About;
